export default __webpack_public_path__ + "static/media/send-audio.d444b2b6.svg";